// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:51:20

export default {
  "id": "unscrew-wood-puzzle",
  "slug": "unscrew-wood-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f096ae533863419c93d52303436357a4-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f096ae533863419c93d52303436357a4/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Unscrew Wood Puzzle",
      "description": "Unscrew Wood Puzzle: Screw Jam is an engaging puzzle game that combines logic, strategy, and dexterity in a tactile experience. Players are challenged to solve intricate puzzles involving bolts, nuts, and screws. With hundreds of unique levels, this game provides a blend of relaxation and mental stimulation, perfect for casual gamers and puzzle enthusiasts alike. The beautifully designed wooden and metallic elements create a visually appealing and satisfying gameplay experience.",
      "instructions": "- Objective: Unscrew bolts and unblock pieces to solve puzzles.\n- Controls: Tap, drag, and pinch to rotate screws, move pieces, and zoom in/out.\n- Gameplay: Unscrew in the correct sequence to clear obstacles and complete the level.\n- Tips: Plan your moves and focus on interlocking mechanisms to avoid getting stuck.- ",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "wood"
      ]
    },
    "zh-CN": {
      "title": "木块解谜",
      "description": "螺丝木块解谜：螺丝卡顿是一款结合逻辑、策略和手感的趣味益智游戏。玩家需解决涉及螺栓、螺母和螺丝的复杂谜题。拥有数百个独特关卡，这款游戏融合了放松和心智刺激，非常适合休闲玩家和谜题爱好者。精心设计的木制和金属元素营造了视觉上吸引人且令人满足的游戏体验。",
      "instructions": "- 目标：拧下螺栓，解开零件以解决谜题。\n- 控制方式：点击、拖动和捏合以旋转螺栓、移动零件和缩放。\n- 游戏玩法：按照正确顺序拧螺栓以清除障碍并完成关卡。\n- 小贴士：规划你的动作并专注于互锁机制以避免卡住。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家",
        "2D",
        "木头"
      ]
    },
    "zh-TW": {
      "title": "旋開木頭謎題",
      "description": "鬆開木頭謎題：螺絲卡住是一款結合邏輯、策略和靈巧的觸覺體驗遊戲。玩家將挑戰解開涉及螺絲、螺母和螺釘的複雜謎題。遊戲內含有數百個獨特關卡，結合放鬆與心智挑戰，適合普通玩家和謎題愛好者。美麗設計的木質和金屬元素，打造出視覺上吸引人且令人滿足的遊戲體驗。",
      "instructions": "- 目標：旋開螺絲和移除阻礙物來解謎。\n- 控制方式：點擊、拖動和擠壓來旋轉螺絲、移動零件和拉近/拉遠。\n- 遊戲玩法：按照正確的順序旋開螺絲以清除障礙物並完成關卡。\n- 試題：規劃你的動作並專注於互扣機制以避免卡住。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "木頭"
      ]
    },
    "zh-HK": {
      "title": "解開木頭謎題",
      "description": "Unscrew Wood Puzzle: Screw Jam 係一個充滿挑戰的益智遊戲，結合邏輯、策略同敏捷度於觸感體驗之中。玩家需要解開涉及螺絲、螺帽同螺釘的複雜謎題。遊戲內有超過百級獨特關卡，提供放鬆同時又富啟發性的遊戲體驗，適合普通玩家同益智遊戲愛好者。美觀設計的木質同金屬元素，創造視覺上吸引人又滿足的遊戲體驗。",
      "instructions": "- 目標：旋松螺絲和解鎖零件以解開謎題。\n- 控制方式：點擊、拖動及縮放以旋轉螺絲、移動零件及拉近/拉遠視野。\n- 遊戲玩法：按照正確順序旋松螺絲以清除障礙並完成關卡。\n- 試題：規劃你的動作並重點關注互扣機制以避免卡關。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "2D",
        "木頭"
      ]
    },
    "ja": {
      "title": "木のパズルを緩める",
      "description": "アンサクリュー・ウッド・パズル：スクリュー・ジャムは、ロジック、戦略、器用さを組み合わせた触覚体験を提供する魅力的なパズルゲームです。プレイヤーは、ボルト、ナット、スクリューを含む複雑なパズルを解く挑戦に直面します。数百のユニークなレベルを誇るこのゲームは、リラクゼーションと知的刺激のバランスが取れたもので、カジュアルなゲーマーやパズルの愛好家双方に最適です。美しくデザインされた木製と金属製の要素が、視覚的に魅力的で満足感のあるゲーム体験を生み出します。",
      "instructions": "- 目標: ボルトを緩め、パーツを解除してパズルを解く。\n- コントロール: タップ、ドラッグ、ピンチしてボルトを回転させ、パーツを動かし、ズームイン/アウトする。\n- ゲームプレイ: 正しい順序で緩めると障害を解除し、レベルをクリアする。\n- ツイック: 手順を計画し、干渉機構に焦点を当てて、ごっちゃになるのを避けよう。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "木"
      ]
    },
    "ko": {
      "title": "나무 퍼즐을 풀어내기",
      "description": "비빈 나무 퍼즐: 스crews Jam은 녹음, 전략, 민첩성을 결합한 터치 경험을 제공하는 흥미로운 퍼즐 게임입니다. 플레이어는 볼트, 나사, 스crews를 사용한 복잡한 퍼즐을 해결하는 도전을 받습니다. 수백 개의 독특한 레벨로, 이 게임은 휴식과 지적 자극의 조화를 이루어 캐주얼 게이머와 퍼즐 애호가 모두에게 적합합니다. 아름다운 디자인의 나무와 금속 요소가 시각적으로 매력적이고 만족스러운 게임 경험을 제공합니다.",
      "instructions": "- 목표: 조인트를 풀고 조각을 해제하여 퍼즐을 해결합니다.\n- 조작법: 탭하고 드래그하고 핀치하여 밑줄을 회전시키고 조각을 움직이고 확대/축소합니다.\n- 게임플레이: 올바른 순서로 풀어서 장애물을 통과하고 레벨을 완료합니다.\n- 팁: 이동 계획을 세우고 결합 기계에 주의하여 갇히지 않도록 합니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "나무"
      ]
    },
    "fr": {
      "title": "Désenvisser le puzzle en bois",
      "description": "Unscrew Wood Puzzle: Screw Jam est un jeu de puzzle captivant qui combine logique, stratégie et dextérité dans une expérience tactile. Les joueurs sont défiés pour résoudre des puzzles complexes impliquant des vis, des écrous et des boulons. Avec des centaines de niveaux uniques, ce jeu offre une combinaison de relaxation et de stimulation mentale, parfait pour les joueurs occasionnels et les passionnés de puzzles. Les éléments en bois et en métal magnifiquement conçus créent une expérience de jeu visuellement attrayante et satisfaisante.",
      "instructions": "- Objectif : Démonter les vis et débloquer les pièces pour résoudre les puzzles.\n- Commandes : Tappez, faites glisser et pincez pour faire pivoter les vis, déplacer les pièces et zoomer en avant/arrière.\n- Gameplay : Démonter dans le bon ordre pour éliminer les obstacles et terminer le niveau.\n- Conseils : Planifiez vos mouvements et concentrez-vous sur les mécanismes d'encastrement pour éviter de vous bloquer.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "bois"
      ]
    }
  }
};
